import { useTranslation } from "react-i18next";
import { useInView } from "@/hooks/useInView";

const entries = [
  {
    product: "Spinosad", dose: "2 ml/L", blockKey: "blockA3",
    color: "hsl(177 58% 52%)", date: "12 Mar", worker: "Carlos M.", priorityKey: "high",
  },
  {
    product: "Abamectin", dose: "1.5 ml/L", blockKey: "blockB7",
    color: "hsl(213 70% 51%)", date: "8 Mar", worker: "Ana R.", priorityKey: "medium",
  },
  {
    product: "Copper", dose: "3 g/L", blockKey: "blockC2",
    color: "hsl(123 43% 44%)", date: "3 Mar", worker: "Jorge L.", priorityKey: "low",
  },
];

const priorityConfig: Record<string, { bg: string; text: string }> = {
  high: { bg: "bg-red-100 text-red-700", text: "High" },
  medium: { bg: "bg-yellow-100 text-yellow-700", text: "Medium" },
  low: { bg: "bg-emerald-100 text-emerald-700", text: "Low" },
};

export function TreatmentRecordsIllustration() {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  return (
    <div ref={ref} className="rounded-2xl border border-landing-border bg-white p-6 shadow-soft">
      <p className="mb-4 text-sm font-semibold text-foreground">
        {t("landing.illustrations.treatmentLog", "Treatment Log")}
      </p>

      <div className="relative space-y-4 pl-4">
        <div className="absolute left-[7px] top-1 bottom-1 w-px bg-muted-foreground/20" />

        {entries.map((e, i) => {
          const prio = priorityConfig[e.priorityKey];
          return (
            <div
              key={i}
              className="relative flex items-center gap-3 transition-all duration-350"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(12px)",
                transitionDelay: `${i * 0.15}s`,
              }}
            >
              <span
                className="absolute -left-4 top-1 h-3.5 w-3.5 rounded-full border-2 border-white flex-shrink-0"
                style={{ backgroundColor: e.color }}
              />
              <div className="flex flex-col gap-0.5 min-w-0 flex-1">
                <span className="text-sm font-medium text-foreground">{e.product}</span>
                <div className="flex flex-wrap gap-1.5">
                  <span className="rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium text-muted-foreground">{e.dose}</span>
                  <span className="rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium text-muted-foreground">
                    {t(`landing.illustrations.${e.blockKey}`, e.blockKey.replace("block", "Block "))}
                  </span>
                </div>
              </div>
              <span className="text-[11px] text-muted-foreground whitespace-nowrap">{e.date}</span>
              <span className="text-[11px] font-medium text-foreground whitespace-nowrap">{e.worker}</span>
              <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${prio.bg}`}>
                {t(`landing.illustrations.priority${e.priorityKey.charAt(0).toUpperCase() + e.priorityKey.slice(1)}`, prio.text)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
